import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const ReportsIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} fill={color} {...props}>
    <path
      d="M3.83333 12.5H9.66667V14.1667H3.83333V12.5ZM3.83333 9.16668H12.1667V10.8333H3.83333V9.16668ZM3.83333 5.83334H12.1667V7.50001H3.83333V5.83334ZM13.8333 2.50001H10.35C10 1.53334 9.08333 0.833344 8 0.833344C6.91667 0.833344 6 1.53334 5.65 2.50001H2.16667C2.05 2.50001 1.94167 2.50834 1.83333 2.53334C1.50833 2.60001 1.21667 2.76668 0.991667 2.99168C0.841667 3.14168 0.716667 3.32501 0.633333 3.52501C0.55 3.71668 0.5 3.93334 0.5 4.16668V15.8333C0.5 16.0583 0.55 16.2833 0.633333 16.4833C0.716667 16.6833 0.841667 16.8583 0.991667 17.0167C1.21667 17.2417 1.50833 17.4083 1.83333 17.475C1.94167 17.4917 2.05 17.5 2.16667 17.5H13.8333C14.75 17.5 15.5 16.75 15.5 15.8333V4.16668C15.5 3.25001 14.75 2.50001 13.8333 2.50001ZM8 2.29168C8.34167 2.29168 8.625 2.57501 8.625 2.91668C8.625 3.25834 8.34167 3.54168 8 3.54168C7.65833 3.54168 7.375 3.25834 7.375 2.91668C7.375 2.57501 7.65833 2.29168 8 2.29168ZM13.8333 15.8333H2.16667V4.16668H13.8333V15.8333Z"
    />
  </svg>
);

ReportsIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

ReportsIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(16, 18),
};

export default ReportsIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/reports.js